// Central API configuration.
// Single source of truth for the backend API base URL used across the client.
// Update this value to point the whole app at a different backend.
export const ServerUrl = "https://va-sample.tpvai.com/api/v1/";

export default ServerUrl;
